import { useTheme } from "next-themes";
import { Toaster as Sonner, toast } from "sonner";

type ToasterProps = React.ComponentProps<typeof Sonner>;

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = "system" } = useTheme();

  return (
    <Sonner
      theme={theme as ToasterProps["theme"]}
      className="toaster group"
      toastOptions={{
        classNames: {
          // Same editorial glass recipe as the Radix toaster
          // (src/components/ui/toast.tsx): card in light mode, dark
          // ink-gradient + blur + hairline white border in dark.
          // GOOGIE-SURFACE-1 — `g-toast` is the hook googie.css
          // repaints through. The editorial-glass classes below stay
          // for anywhere the redesign is off (the marketing site, a
          // public portal); inside `.googie` they are overridden with
          // the same --g-card2 glass every row and card wears, which
          // is why a toast used to be the one flat ink card floating
          // on the app. The `destructive`/`data-type` hooks are what
          // give an error toast its hue.
          toast:
            "g-toast group toast group-[.toaster]:rounded-2xl group-[.toaster]:border group-[.toaster]:border-border group-[.toaster]:bg-card group-[.toaster]:text-foreground group-[.toaster]:shadow-lg group-[.toaster]:backdrop-blur-xl dark:group-[.toaster]:border-white/10 dark:group-[.toaster]:bg-transparent dark:group-[.toaster]:bg-[linear-gradient(180deg,rgba(12,15,23,0.92)_0%,rgba(18,22,32,0.85)_100%)] dark:group-[.toaster]:text-white dark:group-[.toaster]:shadow-[0_24px_48px_-12px_rgba(0,0,0,0.55),0_2px_10px_rgba(0,0,0,0.35)]",
          title: "group-[.toast]:font-medium",
          description: "group-[.toast]:text-muted-foreground dark:group-[.toast]:text-white/60",
          actionButton: "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground",
          cancelButton: "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground",
        },
      }}
      {...props}
    />
  );
};

export { Toaster, toast };
